import React, { useMemo } from 'react'
import { BaseEditorButton } from 'src/editor/shared/entities/base-editor-button'
import {
  FormInterface,
  FormSubmitButtonInterface,
} from 'src/shared/types/entities/form-interface'
import { FormBaseSubEntity } from './form-base-sub-entity'

interface FormSubmitButtonSubEntityProps {
  formEntity: FormInterface
  submitButtonSubEntity: FormSubmitButtonInterface
}

export const FormSubmitButtonSubEntity = ({
  formEntity,
  submitButtonSubEntity,
}: FormSubmitButtonSubEntityProps) => {
  const entity = useMemo(
    () => ({
      ...submitButtonSubEntity,
      ...formEntity.buttonCommonStyles,
    }),
    [submitButtonSubEntity, formEntity.buttonCommonStyles],
  )

  return (
    <FormBaseSubEntity
      title={'entity_settings.submit_button.header'}
      formEntity={formEntity}
      subEntity={submitButtonSubEntity}
    >
      <BaseEditorButton entity={entity} />
    </FormBaseSubEntity>
  )
}
